<template>
	<div class="answer-app">
		<!--nav-->
		<div class="detail-nav">
			<router-link to="/">
				<img src="images/index.png" />首页
			</router-link>>
			<a>幼儿教育学</a>
			<span>幼儿教育学</span>
		</div>

		<!-- answer -->
		<div class="answer-box">
			<div class="answer-box-left">
				<div class="answer-title">
					<p>
						<span>
							<i>1</i>/
							<i>100</i>
						</span>
						<em>单选题</em>
					</p>
					<strong>
						<em>2018.4.14【渝中】综合基础知识真题</em>
					</strong>
					<button class="answer-title-que" @click="showQueWin = true">答疑</button>
					<el-dialog :visible.sync="showQueWin" width="400px">
						<div class="win-que">
							<img src="/images/an_11.png" alt />
							<div>
								<img src="https://www.sz517.com/static/home/images/dyh.jpg" alt />
							</div>扫二维码加入答疑QQ群
						</div>
					</el-dialog>
					<button class="answer-title-wrong" @click="openWrongWin">纠错</button>
					<el-dialog :visible.sync="showWrongWin" width="480px">
						<div class="win-wrong">
							<h3>纠错</h3>
							<el-form ref="form">
								<el-form-item>
									<el-input type="textarea" v-model="wrongValue" placeholder="请输入纠错内容"></el-input>
								</el-form-item>
								<el-button type="primary" @click="errorCorrection()">确认</el-button>
							</el-form>
						</div>
					</el-dialog>
					<button
						class="answer-title-col"
						:class="{'col-active': data.favorite==1}"
						@click="setCollect(data.favorite)"
					>收藏</button>
				</div>

				<!-- 题目 -->
				<div class="answer-que" :class="answerClass">
					<el-carousel
						trigger="click"
						:autoplay="false"
						ref="testCarousel"
						@change="changeCarousel"
						indicator-position="none"
						arrow="never"
						:height="carouselHeight+'px'"
						:loop="false"
					>
						<el-carousel-item v-for="(item,index) in que" :key="index" name="index">
							<div class="answer-carousel" ref="carouselH">
								<div class="answer-que-title">
									<aside :class="{'answer-que-title-xmp':isUnfold}" v-if="testType == 6">
										下列请求权中，
										<span class="right">123</span>能适用诉讼时效的请求权不包括( )。
									</aside>
									<xmp :class="{'answer-que-title-xmp':isUnfold}" v-else>{{item}}</xmp>

									<div class="demo-image__preview" v-if="titleUrl">
										<el-image
											style="width: 100%; height: 100%"
											:src="titleUrl"
											:preview-src-list="titleSrcList"
										></el-image>
									</div>
									<p @click="setTitleUnfold">{{setTitleText}}</p>
								</div>
								<div class="answer-que-option">
									<div class="answer-que-option-title">1. This passage mainly talks about_________ .</div>
									<p>
										<em>A</em>
										<xmp>正确正确正确正确正确</xmp>
									</p>
									<p>
										<em>B</em>
										<xmp>正确正确正确正确正确</xmp>
									</p>
									<p>
										<em>?</em>
										<xmp>不会</xmp>
									</p>
									<!-- 填空题 start -->
									<p v-if="testType==6">
										<em>1</em>
										<el-form :model="formOption">
											<el-form-item>
												<!-- 显示解析不能再编辑 -->
												<el-input v-model="formOption[index]" placeholder="请输入答案" :readonly="showParsing"></el-input>
											</el-form-item>
										</el-form>
									</p>
									<!-- 填空题 end -->
								</div>
								<div class="answer-que-option-btn" v-if="testType == '2' || testType == '6'">
									<el-button
										type="success"
										@click="testType==2 && confirmAnswer();testType==6 && fillInTheBlank()"
									>确认</el-button>
									<!--多选题                          填空题 -->
								</div>
							</div>
						</el-carousel-item>
					</el-carousel>

					<div class="answer-que-btn">
						<!-- 没有解析按钮 answer-que-btn-noParsing -->
						<!-- :class="{'el-button--primary':page!=1}" -->
						<el-button class="answer-prev" @click="prevCarousel();">上一题</el-button>
						
						<el-button class="el-button--primary answer-next" @click="nextCarousel();">下一题</el-button>
						<el-button class="answer-parsing" @click="showParsingNote">
							<img src="/images/an_4.png" />查看答案与解析
						</el-button>
					</div>

					<!-- 解析 -->
					<div class="parsing" v-if="showParsing">
						<div class="parsing-title">
							<span v-if="data.answer">
								正确答案：
								<em>{{data.answer}}</em>
								<!-- <em>A</em>
								<em>A</em>
								<em>A</em>-->
							</span>
							<span class="wrong" v-if="data.answer">
								你的答案：
								<em>{{answer_list[page]}}</em>
								<!-- <em>A</em>
								<em>A</em>s
								<em>A</em>-->
							</span>
							<span v-else>解析</span>
						</div>
						<xmp>{{data.analysis}}</xmp>
					</div>

					<!-- 笔记 -->
					<div class="answer-note" v-if="showNote">
						<div class="parsing-title">本题笔记</div>
						<aside>
							<p>
								<textarea placeholder="请输入笔记内容" rows="3" v-model="noteValue"></textarea>
							</p>
							<el-button type="primary" size="small" @click="addnote()">保存</el-button>
						</aside>

						<div class="answer-note-list">
							<div class="note-list" v-for="item in noteList" :key="item.id">
								<div class="note-list-tit">
									<div class="note-list-photo">
										<el-avatar :size="50" :src="item.image"></el-avatar>
									</div>
									<div class="note-list-info">
										<p style="margin-top:4px">{{item.nickname}}</p>
										<p>{{item.create_time}}</p>
									</div>
									<button
										class="note-list-dete"
										v-if="user_id == item.uid"
										title="删除"
										@click="deletenote(item.id)"
									>删除</button>
									<button
										class="note-list-praise"
										v-else
										@click="liked==false && zannote(item.id,$event)"
									>{{item.praise}}</button>
								</div>
								<div class="note-list-text">{{item.content}}</div>
							</div>
							<button class="answer-list-more" @click="getMoreNote()">加载更多笔记</button>
						</div>
					</div>
				</div>
			</div>

			<div class="answer-box-right">
				<!--时间 返回-->
				<div class="answer-time">
					<p>
						<img src="images/an_2.png" />
						<span>{{timeStr}}</span>
					</p>
					<a title="交卷" @click="stopKeepTime">
						<img src="images/an_3.png" />
					</a>
				</div>

				<!--答题卡-->
				<div class="answer-card">
					<h3>
						<img src="images/an_7.png" /> 答题卡
					</h3>
					<div class="card card-a">
						<!--错误  class="wrong"正确 class="right"-->
						<el-button
							v-for="item in count"
							:key="item"
							:class="{right:answer_list[item],hide:!(item>=min && item<=max)}"
							@click="Answersheet(1)"
						>{{item}}</el-button>
					</div>
					<p>
						<el-form>
							<el-form-item>
								<el-select v-model="selectedValue" @change="quescount(selectedValue)">
									<el-option
										v-for="(item,index) in cardSelect"
										:key="index"
										:value="index"
										:label="item.label"
									></el-option>
								</el-select>
							</el-form-item>
						</el-form>
					</p>
				</div>
				<!--相关推荐-->
				<div class="answer-recom">
					<h3>
						<img src="images/an_5.png" /> 相关推荐
					</h3>
					<dl v-for="item in book" :key="item.id">
						<a @click="jump(item.id)">
							<dt>
								<img :src="'https://www.sz517.com'+item.icon" />
							</dt>
							<dd>{{item.name}}</dd>
							<p>￥{{item.price}}</p>
						</a>
					</dl>
				</div>
			</div>

			<div class="clear"></div>
		</div>
	</div>
</template>
<script>
	import test from "../../../public/css/test.css";
	export default {
		name: "answer-app",
		data() {
			return {
				que: [
					"下列请求权中，能适用诉讼时效的请求权不包括( )。",
					"下列请求权中，能适用诉讼时效的请求权不包括( )。下列请求权中，能适用诉讼时效的请求权不包括( )。下列请求权中，能适用诉讼时效的请求权不包括( )。下列请求权中，能适用诉讼时效的请求权不包括( )。",
				],
				sign_id: 0,
				liked: false,
				qid: 0,
				user_id: 8522,
				count: 100,
				answer_list: [],
				answer_true_list: [],
				your_answer: "不会",
				data: [],
				titleUrl: "",
				titleSrcList: ["/images/a2.png"],
				btnDisabled: true, //禁用prev  next按钮
				noteValue: "", //笔记文本框
				wrongValue: "", //纠错文本框
				noteList: [],
				cardSelect: [],
				page: 1,
				selectedValue: "1",
				testType: "",
				formOption: [],
				titleHeight: "", //题干高度
				isUnfold: false, //是否展开
				setTitleText: "展开文章",
				showParsing: false, //显示解析
				showNote: false, //显示笔记
				showQueWin: false,
				showWrongWin: false,
				h: 0,
				m: 0,
				s: 0,
				timeStr: "",
				timer: null,
				note_page: 1,
				book: [],
				answerOption: ["A", "B", "C", "D", "E", "F", "G"],
				answer_true: 0,
				answers: 0,
				crumbs: [],
				max: 50,
				min: 1,
				correctAnswer: [],
				wrongAnswer: [],
				numberOfHorizontalLines: 0,
				answerTheQuestion: [4, 5, 7, 8, 9, 1004, 1104, 1304], //解答题题型
				endtime: "2020.08.26 18:00:00",
				endStr: "00:00:00",
				carouselActive: "0",
				carouselHeight: "",
			};
		},
		methods: {
			// 初始化滑动高度
			initCarousel() {
				this.$nextTick(() => {
					this.carouselHeight = this.$refs.carouselH[0].offsetHeight + 30;
				});
			},
			//滑动监听
			changeCarousel(e) {
				this.carouselActive = e;
				this.$nextTick(() => {
					this.carouselHeight = this.$refs.carouselH[e].offsetHeight + 30;
				});
			},
			// 上一题
			prevCarousel() {
				this.$refs.testCarousel.setActiveItem(this.carouselActive - 1);
			},
			// 下一题
			nextCarousel() {
				this.$refs.testCarousel.setActiveItem(this.carouselActive + 1);
			},
			//答题卡跳转
			Answersheet(index) {
				this.$refs.testCarousel.setActiveItem(index);
			},
			// 显示解析
			showParsingNote() {
				this.showParsing = true;
				this.showNote = true;
			},
			// 展开文章
			setTitleUnfold() {
				if (this.isUnfold) {
					this.isUnfold = false;
					this.setTitleText = "展开文章";
				} else {
					this.isUnfold = true;
					this.setTitleText = "收起文章";
				}
			},
			//纠错
			openWrongWin() {
				this.showWrongWin = true;
			},

			//收藏
			setCollect(status) {
				//判断这道题用户是否收藏过
				if (status == 1) {
					//收藏过
					//询问用户是否取消收藏
					this.$confirm("是否要取消收藏？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
						.then(() => {
							//点击确定
							var param = {
								uid: 8522,
								qid: this.data.id,
							};
							this.$post("deletefavorite", param).then((res) => {
								if (res.code === 200) {
									this.getIniQues();
									this.$message({
										type: "success",
										message: "删除成功!",
										showClose: true,
									});
								} else {
									this.$message({
										type: "success",
										message: "删除失败，请稍后重试!",
										showClose: true,
									});
								}
							});
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消删除",
								showClose: true,
							});
						});
				} else {
					//没收藏
					this.getIniQues();
					var param = {
						uid: 8522,
						tid: 4,
						gid: this.data.id,
						create_time: Date.parse(new Date()) / 1000,
						update_time: Date.parse(new Date()) / 1000,
					};
					this.$post("addfavorite", param).then((res) => {
						if (res.code === 200) {
							this.$message({
								type: "success",
								message: "收藏成功!",
								showClose: true,
							});
						}
					});
				}
			},
			//计时器
			keepTime() {
				//定义计时函数
				this.s = this.s + 1;
				if (this.s >= 60) {
					this.s = 0;
					this.m = this.m + 1; //分钟
				}
				if (this.m >= 60) {
					this.m = 0;
					this.h = this.h + 1; //小时
				}
				this.timeStr =
					this.toDub(this.h) +
					":" +
					this.toDub(this.m) +
					":" +
					this.toDub(this.s);
			},

			stopKeepTime() {
				this.stopTime();
				this.$confirm("您确定要结束答题吗？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
					.then(() => {
						this.$router.push({
							path: "/result",
						});
					})
					.catch(() => {
						this.stopTime();
						this.startTime();
					});
			},

			resetTime() {
				//重置
				clearInterval(this.time);
				this.h = 0;
				this.m = 0;
				this.ms = 0;
				this.s = 0;
				this.timeStr = "00:00:00";
			},

			startTime() {
				//开始
				this.timer = setInterval(this.keepTime, 1000);
			},

			stopTime() {
				//暂停
				clearInterval(this.timer);
			},

			toDub(n) {
				//补0操作
				if (n < 10) {
					return "0" + n;
				} else {
					return "" + n;
				}
			},
			// 倒计时
			endTime() {
				var int = setInterval(() => {
					var end = new Date(this.endtime).getTime();
					var now = new Date().getTime();
					var obj = "";
					if (end > now) {
						let time = (end - now) / 1000; // 获取天、时、分、秒
						let hou = parseInt((time % (60 * 60 * 24)) / 3600);
						let min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60);
						let sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60);
						obj = {
							hou: this.toDub(hou),
							min: this.toDub(min),
							sec: this.toDub(sec),
						};
					} else {
						obj = {
							hou: "00",
							min: "00",
							sec: "00",
						};
						clearInterval(int);
					}
					this.endStr = obj.hou + ":" + obj.min + ":" + obj.sec;
				}, 1000);
			},
		},

		created() {
			this.resetTime();
			this.startTime();

			this.qid = this.$route.query.qid;
		},
		mounted() {
			this.initCarousel();
		},
		computed: {
			answerClass() {
				return {
					"answer-title-img": this.titleUrl, //题干是否有图
					"answer-gap": this.testType == "6", //填空题
					"answer-word": this.testType == "10", //阅读题
				};
			},
		},
	};
</script>

<style>
	.el-dialog {
		border-radius: 10px !important;
	}

	.hide {
		display: none !important;
	}
</style>
